<template>
   <div class="new-discount">
    <header>
      <div>New Discount</div>
      <router-link :to="{name: 'ManageDiscounts'}">
        Back to list
      </router-link>
    </header>
    <discount-form
      v-bind="discount"
      :disabled="isSaving"
      @submit="save"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '@/store';
import DiscountForm from '@/views/admin/discounts/DiscountForm.vue';

export default {
  name: 'NewDiscount',
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('fetchAllDiscounts').then(() => next());
  },
  components: {
    DiscountForm,
  },
  data() {
    return {
      isSaving: false,
      discount: null,
    };
  },
  methods: {
    ...mapActions(['createDiscount']),
    save(form) {
      this.isSaving = true;
      this.createDiscount({
        ...form,
        active: true,
      }).then(() => {
        this.$router.push({
          name: 'ManageDiscounts',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-discount {
  header {
    text-align: center;
    display: block;
    div {
      font-weight: 500;
    }
    a {
      font-size: var(--font-small);
    }
  }
}
</style>
